// TODO 尾部可以不删除默认导入带的.vue，使用的时候会遍历删除 (别的地方跳转用到的话最好去掉)
export const routesUrl = {
	/** M&V历史 */
	mvList: '/pages/mv-list/index',
	/** RUCAM答题历史 */
	rucamList: '/pages/rucam-list/index',
	/** M&V量表 */
	MV: '/pages/MV/index',
	/** RUCAM问卷 */
	rucam: '/pages/rucam/index',
}

/** 测试使用，只在开发环境生效 */
export const testUrl = process.env.NODE_ENV === 'development' ? {} : {
	getCode: '/pages/test/getCode',
	defaultPage: '/pages/test/defaultPage'
}

/** 导航栏 灰底的页面样式 */
// @ts-ignore
const navigationBlock: navigationBlockType = (title = '') => ({
	navigationBarTitleText: title,
	navigationBarBackgroundColor: '#EEF1F4',
	navigationBarTextStyle: 'black'
})


const routes = [
	{
		path: routesUrl.rucam,
		style: {
			navigationBarTitleText: 'RUCAM量表',
			navigationStyle: 'custom'
		},
	},
	{
		path: routesUrl.MV,
		style: {
			navigationBarTitleText: 'M&V量表',
			navigationStyle: 'custom'
		},
	},
	{
		path: routesUrl.rucamList,
		style: {
			navigationBarTitleText: 'RUCAM答题历史',
			navigationStyle: 'custom'
		},
	},
	{
		path: routesUrl.mvList,
		style: {
			navigationBarTitleText: 'M&V量表答题历史',
			navigationStyle: 'custom'
		},
	},
] as routesType
//! 上面这行不能去

export default routes.concat(Object.values(testUrl).map(el => ({ path: el }))).map(el => {
	el.path = el.path.replace(/\/pages/g, 'pages').replace(/\.vue/g, '');
	return el
})
